import { render, staticRenderFns } from "./ValorationPositioning.vue?vue&type=template&id=c0f61660&scoped=true&lang=pug"
import script from "./ValorationPositioning.vue?vue&type=script&lang=js"
export * from "./ValorationPositioning.vue?vue&type=script&lang=js"
import style0 from "./ValorationPositioning.vue?vue&type=style&index=0&id=c0f61660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f61660",
  null
  
)

export default component.exports